__webpack_require__.p = "//lesson-homework-micro-front.staging.it-incubator.ru/";